import { Component} from '@angular/core';
import { LoaderService } from 'modules/app/services/loader.service';
import { ProductViewHelperService } from 'modules/foc/services/product-view-helper.service';

@Component({
  selector: 'save-alert',
  styleUrls: [ './save-alert.style.scss' ],
  templateUrl: './save-alert.template.html',
  standalone: false
})
export class SaveAlert {
  
  constructor(
    private productViewHelperService : ProductViewHelperService,
    private loaderService : LoaderService
  ) {}

  saveAlertActionSelection(val) {
    if(val == false) { //Save the recording
      this.loaderService.hideLoader();
      this.productViewHelperService.saveRecordedAudio.next(null);
    }
    this.productViewHelperService.saveAlertAction.next(val);
  }
}